import AccordionLayout from '../../components/common/Accordion';

const accordions = [
  {
    title: 'Do I need any special software to use DMV Navigator?',
    detail: 'No special software required! DMV Navigator is Browser-based, and optimized for tablets, desktops, and laptops with an internet connection.',
  },
  {
    title: 'How long does a transaction take?',
    detail: 'Most information is retrieved within seconds, depending on the state and type of request. DMV Nav’s system ensures speed and accuracy every step of the way.',
  },
  {
    title: 'Is DMV Navigator secure or handling sensitive customer information?',
    detail: 'Yes! We use advanced encryption, secure servers, and strict access controls to keep your data safe.',
  },
  {
    title: 'Can DMV Navigator handle out of state transactions?',
    detail: 'Absolutely. DMV Navigator is designed to manage multi-state transactions, perfect for financial institutions that work with customers from across the country.',
  },
];

function About() {
  const handleAboutUs = () =>{
    window.open('https://outlook.office.com/bookwithme/user/9d5c85f490a7412591901dccb51d6c48%40culoansource.com/meetingtype/97eab26e-36af-4ab1-a216-9e3d2162b498?anonymous&isanonymous=true', '_blank', 'noopener,noreferrer');
  }

  return (
    <>
    <div className='flex flex-row w-full mb-16'>
      <div className='flex flex-col p-4 pt-28 w-1/2'>
        <div className='text-3xl font-bold mb-6 pt-4'>
            About DMV Navigator
        </div>

        <div className='text-lg text-gray-700 mb-6'>
          DMV Navigator is a comprehensive digital platform designed to streamline and simplify vehicle title and registration processes. 
          Developed by CULS Lending Solutions, it offers users such as loan officers, loan processors, and title clerks access to accurate tax calculations, 
          registration fees, and required documentation for every jurisdiction. In addition, DMV Navigator connects directly to state and national databases to verify lien and title status. By automating complex tasks, DMV Navigator reduces errors, ensures 
          compliance, and enhances operational efficiency.
        </div>

        <div>
          <button className='border border-green-800 px-7 py-3 rounded-lg text-green-800 hover:bg-green-800 hover:text-white' onClick={handleAboutUs}>
            Learn more about us
          </button>
        </div>
      </div>

      <div className="relative mt-16 right-0 lg:mr-14 lg:ml-auto w-fit">
        <img
          src="/bg_about.png"
          alt=""
          className="absolute w-full top-0 left-0 rounded-3xl"
        />
        <img
          src="/about.png"
          alt=""
          className="relative top-16 left-14 z-10 w-full rounded-xl"
        />
      </div>
    </div>

    <div className='bg-gray-50 flex flex-col items-center rounded-xl p-32 mt-32'>
      <div className='text-3xl font-bold mb-8'>
        Questions about DMV Navigator?
      </div>

      <div className='w-[700px] flex flex-col gap-6'>
        {accordions.map((accordion, index) => (
          <AccordionLayout
            key={index}
            {...accordion}
          />
        ))}

      </div>
    </div>
  </>
  )
}

export default About;
